// theme
import ThemeProvider from './theme'
// components
import MotionLazyContainer from './components/animate/MotionLazyContainer'

import DirectionWrapper from 'src/components/DirectionWrapper'
import Router from 'src/components/routes/root'

// ----------------------------------------------------------------------

export default function App() {
  return (
    <DirectionWrapper>
      <MotionLazyContainer>
        <ThemeProvider>
          <Router />
        </ThemeProvider>
      </MotionLazyContainer>
    </DirectionWrapper>
  )
}
